import 'react-dates/initialize';

import React, { Component } from 'react';
import firebase from '../helper/firebase';

import { Link } from 'react-router-dom';

import moment from 'moment';

import Head from '../components/Head';
import Snack from '../components/Snack';
import LoggedOutCard from '../components/LoggedOutCard';
import SectionTitle from '../components/SectionTitle';
import UnpublishedJob from '../components/UnpublishedJob';
import SkeletonCard from '../components/SkeletonCard';
import SkeletonSectionTitle from '../components/SkeletonSectionTitle';

import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import { Title } from '../helper/consts';

import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	CircularProgress,
	// TextField,
	Typography
} from 'material-ui';

import Fade from 'material-ui/transitions/Fade';

import '../styles/Hire.css';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	input: {
		maxWidth: '85%',
		margin: '28px 0'
	}
};

export default class Hire extends Component {
	constructor() {
		super();

		this.state = {
			loading: true,
			authLoading: true,
			loggedIn: false,
			startDate: moment(),
			candidateLoading: true,
			jobLoading: true,
			jid: '',
			startDateLoaded: false
		};
	}

	componentWillUnmount() {
		firebase
			.database()
			.ref(`startDate/${this.state.jid}`)
			.off();
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.setState({
					uid: user.uid,
					user: user.providerData[0],
					loggedIn: true,
					authLoading: false,
					loading: true
				});
				this.getParams();
			} else {
				if (this.state.jid) {
					firebase
						.database()
						.ref(`startDate/${this.state.jid}`)
						.off();
				}
				this.setState({
					loggedIn: false,
					authLoading: false,
					loading: true,
					user: {},
					uid: '',
					candidateLoading: true,
					candidate: {},
					jobLoading: true,
					job: {},
					jid: '',
					startDateLoaded: false,
					startDateObj: {}
				});
			}
		});
	}

	getParams = () => {
		if (
			this.props.location.state &&
			this.props.location.state.jid &&
			this.props.location.state.uid
		) {
			this.setState({ jid: this.props.location.state.jid });
			this.getInfo(
				this.props.location.state.jid,
				this.props.location.state.uid
			);
			this.getStartDate(this.props.location.state.jid);
		} else if (this.props.match.params.jid && this.props.match.params.uid) {
			this.setState({ jid: this.props.match.params.jid });
			this.getInfo(this.props.match.params.jid, this.props.match.params.uid);
			this.getStartDate(this.props.match.params.jid);
		} else {
			this.setState({ error: true });
		}
	};

	getStartDate = jid => {
		const ref = firebase.database().ref();
		ref.child(`startDate/${jid}`).on(
			'value',
			snap => {
				if (snap.val() !== null) {
					console.log(snap.val());
					const startDate = moment(snap.val().startDate);
					this.setState({
						startDate: startDate,
						startDateObj: snap.val(),
						startDateLoaded: true
					});
				} else {
					this.setState({
						startDate: '',
						startDateObj: {},
						startDateLoaded: false
					});
				}
			},
			error => {
				console.log(error);
			}
		);
	};

	dateToDatePicker = date => moment(date).toString();

	dateFromDatePicker = date => moment(date).valueOf();

	getInfo = (jid, uid) => {
		const ref = firebase.database().ref();
		let promises = [];
		let candidatePromise = ref
			.child(`users/${uid}`)
			.once('value')
			.then(candidate => {
				if (candidate.val()) {
					this.setState({
						candidateLoading: false,
						candidate: candidate.val()
					});
				} else {
					this.setState({ error: true });
				}
			});
		promises.push(candidatePromise);
		let jobPromise = firebase
			.firestore()
			.collection('jobs')
			.doc(jid)
			.get()
			.then(job => {
				if (!!job.data()) {
					this.setState({ jobLoading: false, job: job.data() });
				} else {
					this.setState({ error: true });
				}
			});
		promises.push(jobPromise);
		Promise.all(promises)
			.then(() => {
				this.setState({ loading: false });
			})
			.catch(error => {
				this.setState({
					loading: false,
					snackStatus: true,
					snackMessage: 'Error: Please check the link and try again.'
				});
			});
	};

	validate = () => {
		const { startDateError, startDate } = this.state;
		!!startDateError || !startDate
			? this.setState({
					snackStatus: true,
					snackMessage:
						'Please enter a valid start date, after today and less than 1 year away, for the candidate.'
			  })
			: this.confirmStartDate();
	};

	confirmStartDate = () => {
		const ref = firebase.database().ref();
		const { candidate, job, startDate } = this.state;
		const update = {
			uid: candidate.uid,
			timestamp: Date.now(),
			displayName: candidate.displayName || candidate.email,
			email: candidate.email,
			jid: job.jid,
			startDate: moment(startDate).valueOf()
		};
		ref
			.child(`startDate/${job.jid}`)
			.update(update)
			.then(() => {
				this.setState({
					snackStatus: true,
					snackMessage: 'Congratulations. The start date has now been set.'
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	confirmHire = () => {
		const ref = firebase.database().ref();
		const { candidate, job } = this.state;
		let startDate = moment(this.state.startDate).valueOf();
		let promises = [];
		const update = {};
		let usersStage = 4;
		update[`selection/${job.jid}/${candidate.uid}`] = usersStage;
		const jobPromise = firebase
			.firestore()
			.collection('jobs')
			.doc(job.jid)
			.update({
				status: 'hired',
				startDate: startDate
			});
		promises.push(jobPromise);
		update[`applications/${job.jid}/${candidate.uid}/status`] = 'hired';
		update[`startDate/${job.jid}`] = null;
		job.status = 'hired';
		let dbPromise = ref.update(update);
		promises.push(dbPromise);
		Promise.all(promises)
			.then(() => {
				this.setState({
					job,
					snackStatus: true,
					snackMessage:
						'Congratulations. The candidate and posting has now been marked as hired.'
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	renderSetDateCard = () => {
		let html = [];
		html.push(
			<SectionTitle key="set_date_title" title="Candidate Start Date" />
		);
		const { candidate, job } = this.state;
		let card = (
			<Fade key={'applicant_setDateCard'} in={true}>
				<Card className="card">
					<CardHeader title={`Set Start Date`} />
					<CardContent>
						<Typography type="body1">{`Please set the start date for ${
							candidate.displayName
						}. Once you set a start date, we'll send you a reminder to confirm that the candidate has started, after which you can mark the position as filled.`}</Typography>
						<div style={style.input}>
							<SingleDatePicker
								date={this.state.startDate}
								onDateChange={startDate => this.setState({ startDate })}
								focused={this.state.focused}
								onFocusChange={({ focused }) => this.setState({ focused })}
								required={true}
								showDefaultInputIcon={true}
								noBorder={true}
								numberOfMonths={1}
								reopenPickerOnClearDate={true}
								isOutsideRange={() => false}
								hideKeyboardShortcutsPanel={true}
								regular={true}
								daySize={35}
							/>
						</div>
					</CardContent>
					<CardActions>
						{!this.state.startDateLoaded && (
							<Link to={`/Applicants/${job.jid}`}>
								<Button
									key={`cancel`}
									onClick={this.handleDialogDisagree}
									color="primary"
								>
									Cancel
								</Button>
							</Link>
						)}
						<Button onClick={this.validate} key={`set_date`} color="primary">
							{this.state.startDateLoaded ? 'Update' : 'Set'}
						</Button>
					</CardActions>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderConfirm = () => {
		let html = [];
		const { candidate } = this.state;
		let card = (
			<Fade key={'applicant_hire_confirmation'} in={true}>
				<Card className="card">
					<CardHeader title={`Hire ${candidate.displayName}?`} />
					<CardContent>
						<Typography type="body1">
							Please confirm that you have hired {candidate.displayName}. If you
							select agree, the candidate and the referees will be notified and
							this job will be marked as closed and hired. This action cannot be
							undone.
						</Typography>
					</CardContent>
					<CardActions>
						<Button onClick={this.confirmHire} key={`confirm`} color="primary">
							Confirm
						</Button>
					</CardActions>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	closeSnack = () => {
		this.setState({ snackStatus: false, snackMessage: '' });
	};

	render() {
		const now = Date.now();
		return (
			<React.Fragment>
				<Head title={`Hire | ${Title}`} />
				<div id={this.state.loggedIn ? 'loggedInBody' : null} className="body">
					{!!this.state.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{!this.state.authLoading &&
						this.state.loggedIn &&
						(this.state.jobLoading || this.state.candidateLoading) && (
							<SkeletonSectionTitle />
						)}
					{!this.state.authLoading &&
						this.state.loggedIn &&
						(this.state.jobLoading || this.state.candidateLoading) && (
							<SkeletonCard actions={true} content={true} header={true} />
						)}

					{!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.jobLoading &&
						!this.state.candidateLoading &&
						this.state.job &&
						this.state.job.status !== 'hired' &&
						this.renderSetDateCard()}

					{!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.jobLoading &&
						!this.state.candidateLoading &&
						this.state.job &&
						this.state.job.status === 'hired' && (
							<UnpublishedJob status={this.state.job.status} />
						)}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.jobLoading &&
						!this.state.candidateLoading &&
						this.state.startDateObj &&
						this.state.candidate.uid === this.state.startDateObj.uid &&
						this.state.startDateLoaded &&
						this.state.startDateObj.startDate < now && (
							<SectionTitle title="Confirmation" />
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.jobLoading &&
						!this.state.candidateLoading &&
						this.state.startDateObj &&
						this.state.candidate.uid === this.state.startDateObj.uid &&
						this.state.startDateLoaded &&
						this.state.startDateObj.startDate < now &&
						this.renderConfirm()}

					{!this.state.authLoading && !this.state.loggedIn && <LoggedOutCard />}

					<Snack
						snackStatus={this.state.snackStatus}
						snackMessage={this.state.snackMessage}
						closeSnack={() => {
							this.closeSnack();
						}}
					/>
				</div>
			</React.Fragment>
		);
	}
}

// <TextField
//   id="date"
//   label="Start Date"
//   type="date"
//   onChange={this.handleDate}
//   value={`${moment(this.state.startDate).format('YYYY-MM-DD')}`}
//   error={this.state.startDateError}
// />



// WEBPACK FOOTER //
// ./src/pages/Hire.js